<template>
  <a-card :bordered="false">
    <a-row :gutter="[16,32]">
      <a-col :span="12" :offset="4" style='text-align: center'>
        <h2>确认有效评标价</h2>
      </a-col>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-col :span="6" :offset="4">
        最高投标限价（元）：
      </a-col>
      <a-col :span="6" :offset="4">
        进入评标基准价下限【评标价进入评标基准价计算的下限为评标最高限价的85%】：
      </a-col>
    </a-row>
    <a-row :gutter="[16,0]">
      <a-col :span="6" :offset="4">
        <a-input :value="controlPrice" disabled='disabled' />
      </a-col>
      <a-col :span="6" :offset="4">
        <a-input :value="benchmarkPriceDown" disabled='disabled' />
      </a-col>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-col :span="6" :offset="4">
        有效评标价家数：
      </a-col>
    </a-row>
    <a-row :gutter="[16,0]">
      <a-col :span="6" :offset="4">
        <a-input :value="benchmarkPriceSize" disabled='disabled' />
      </a-col>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-col :span="6" :offset="4">
        评标价最高限价（元）：
      </a-col>
    </a-row>
    <a-row :gutter="[16,0]">
      <a-col :span="6" :offset="4">
        <a-input :value="evalControlPrice" disabled='disabled' />
      </a-col>
    </a-row>
    <div style='margin-top: 10px;text-align: center'>
      <a-button type="primary" @click="nextStep">下一步</a-button>
    </div>
  </a-card>
</template>

<script>
import { postAction,getAction } from '@api/manage'
export default {
  name: 'WaterTransportBenchmarkPriceComputeStep1',
  data() {
    return {
      controlPrice: "",
      evalControlPrice:"",
      benchmarkPriceDown: "",
      tentativeAmount: "",
      benchmarkPriceSize: "",
      isCheck: true,
    }
  },
  props: ['sectionId','bidProjectId','workflowInstanceId','instStepId'],
  created() {
    this.getBoOpenConfig();
  },
  methods: {
    getBoOpenConfig() {
      let that = this;
      getAction('/ebid-ce/waterTransportBenchmarkPriceCompute/getBenchmarkPriceInfo/' + this.bidProjectId + "/" + this.sectionId+"/"+this.workflowInstanceId+"/"+this.instStepId , {}).then(res => {
        if (res.success) {
          that.controlPrice = res.result.controlPrice;
          that.evalControlPrice = res.result.evalControlPrice;
          that.tentativeAmount = res.result.tentativeAmount;
          that.benchmarkPriceDown = res.result.benchmarkPriceDown;
          that.benchmarkPriceSize = res.result.benchmarkPriceSize;
        } else {
        }
      })
    },
    nextStep () {
      this.$emit('nextStep')
    }
  }
}
</script>

<style scoped>

</style>